
































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyForm from "@/mixins/form";

import TsUpload from "@/components/upload.vue";

@Component({
  components: {
    TsUpload
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleChange1({ fileList }: any) {}

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交保存吗？",
          onOk: async () => {
            const values: any = {};
            for (const key in fieldValues) {
              if (["install_cost", "earn_ad"].includes(key)) {
                _.set(values, [key], fieldValues[key] * 100);
              } else {
                _.set(values, [key], fieldValues[key]);
              }
            }
            const res = await this.$store.dispatch("stadium/saveTaisamSetting", {
              stadium_id: this.stadiumId,
              ...values
            });
            if (res && res.Message && res.Message == "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  async mounted() {
    const res = await this.$store.dispatch("stadium/getTaisamSetting", {
      stadium_id: this.stadiumId
    });
    // console.log(res);
    if (res && res.Data) {
      this.formData = res.Data;
    }
  }
}
